import PaperIcon from '@/common/assets/icons/paperIcon.svg?react';
import PlusICon from '@/common/assets/icons/plusIcon.svg?react';
import SmallCarIcon from '@/common/assets/icons/smallCarIcon.svg?react';
import TitleDescription from '@/common/components/base/typography/TitleDescription';
import LoadingPage from '@/common/pages/LoadingPage';
import getDamagedTypeQueryOption from '@/common/queries/getDamagedType/getDamagedTypeQueryOPtion';
import AdjusterAdditionalImagesList from '@/modules/adjusterReportModules/adjusterReport/components/imagesFab/imagesList/AdditionalImagesList';
import DamagedPersonImagesList from '@/modules/adjusterReportModules/adjusterReport/components/imagesFab/imagesList/DamagedPersonImagesList';
import AdjusterDocumentImagesList from '@/modules/adjusterReportModules/adjusterReport/components/imagesFab/imagesList/DocumentImagesList';
import AdjusterVehicleImagesList from '@/modules/adjusterReportModules/adjusterReport/components/imagesFab/imagesList/VehicleImagesList';
import { GetFabAdditionalImagesQueryParamsType } from '@/modules/adjusterReportModules/adjusterReport/queries/imageFab/getFabAdditionalImages/getFabAdditionalImagesQuery.type';
import { GetFabImagesQueryParamsType } from '@/modules/adjusterReportModules/adjusterReport/queries/imageFab/getFabImages/getFabImagesQuery.type';
import { GetFabTabsQueryParamsType } from '@/modules/adjusterReportModules/adjusterReport/queries/imageFab/getFabTabs/getFabTabsQuery.type';
import { GetFabVehicleImagesQueryParamsType } from '@/modules/adjusterReportModules/adjusterReport/queries/imageFab/getFabVehicleImages/getFabVehicleImagesQuery.type';
import SwitchTab from '@/modules/adjusterReportModules/IncidentParticipants/components/common/SwitchTab';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box } from 'styled-system/jsx';
import UserIcon from '@/common/assets/icons/user.svg?react';

const AdjusterImagesFabModal = ({
  state,
}: {
  state: GetFabTabsQueryParamsType['state'];
}) => {
  const [activeTab, setActiveTab] = useState(3);
  const { damagedId } = useParams();

  const { data: damaged, isLoading } = useQuery(
    getDamagedTypeQueryOption({
      damaged_pk: damagedId,
      enabled: state === 'propertyDamaged',
    }),
  );
  const vehicleStateHandler = (
    state: GetFabTabsQueryParamsType['state'],
  ): GetFabVehicleImagesQueryParamsType['state'] => {
    switch (state) {
      case 'body':
        return 'bodyAdjusterVehicle';
      case 'initial':
        return 'initialAdjusterVehicle';
      case 'propertyCulprit':
        return 'propertyCulpritAdjusterVehicle';
      case 'propertyDamaged':
        return 'propertyDamagedAdjusterVehicle';
    }
  };
  const documentStateHandler = (
    state: GetFabTabsQueryParamsType['state'],
  ): GetFabImagesQueryParamsType['state'] => {
    switch (state) {
      case 'body':
        return 'bodyAdjusterDocument';
      case 'initial':
        return 'initialAdjusterDocument';
      case 'propertyCulprit':
        return 'propertyCulpritAdjusterDocument';
      case 'propertyDamaged':
        return 'propertyDamagedAdjusterDocument';
    }
  };
  const additionalStateHandler = (
    state: GetFabTabsQueryParamsType['state'],
  ): GetFabAdditionalImagesQueryParamsType['state'] => {
    switch (state) {
      case 'body':
        return 'bodyAdjusterAdditional';
      case 'initial':
        return 'initialAdjusterAdditional';
      case 'propertyCulprit':
        return 'propertyCulpritAdjusterAdditional';
      case 'propertyDamaged':
        return 'propertyDamagedAdjusterAdditional';
    }
  };

  const isVehicle =
    state !== 'propertyDamaged' || damaged?.damaged_type === 'VEHICLE';

  if (isLoading) return <LoadingPage />;

  return (
    <Box pt={'2rem'}>
      <TitleDescription>تصاویر کارشناس</TitleDescription>
      <Box mt="24px">
        <SwitchTab
          activeTab={3}
          tabs={isVehicle ? tabs : damagedTabs}
          getActiveTab={(activeTab: number) => setActiveTab(activeTab)}
        />
        {activeTab === 1 ? (
          <AdjusterVehicleImagesList state={vehicleStateHandler(state)} />
        ) : null}
        {activeTab === 2 ? (
          <DamagedPersonImagesList
            state={'propertyDamagedAdjusterDamagedPerson'}
          />
        ) : null}
        {activeTab === 3 ? (
          <AdjusterDocumentImagesList state={documentStateHandler(state)} />
        ) : null}
        {activeTab === 4 ? (
          <AdjusterAdditionalImagesList state={additionalStateHandler(state)} />
        ) : null}
      </Box>
    </Box>
  );
};
export default AdjusterImagesFabModal;
const tabs = [
  {
    title: ' وسیله‌نقلیه',
    activeTabIndex: 1,
    icon: <SmallCarIcon stroke={'currentColor'} />,
  },
  {
    title: ' مدارک',
    activeTabIndex: 3,
    icon: <PaperIcon stroke={'currentColor'} />,
  },
  {
    title: 'الحاقی',
    activeTabIndex: 4,
    icon: <PlusICon stroke={'currentColor'} />,
  },
];
const damagedTabs = [
  {
    title: ' زیان‌دیده',
    activeTabIndex: 2,
    icon: <UserIcon stroke={'currentColor'} />,
  },
  {
    title: ' مدارک',
    activeTabIndex: 3,
    icon: <PaperIcon stroke={'currentColor'} />,
  },
  {
    title: 'الحاقی',
    activeTabIndex: 4,
    icon: <PlusICon stroke={'currentColor'} />,
  },
];
